import * as immutable from "immutable";
import {IcurationWorklistItem} from "../interfaces/curation-worklist-item.interface";
import {IgenomicsAction} from "../../core/interfaces/genomics-action.interface";
import {CURATION_ACTIONS} from "./curation.actions";
import {IPreviewData} from "@ispm/test/services/preview/preview-data";
import {PreviewStatus} from "@ispm/test/services/preview/preview-status";
import {IGrantedAction, IMultipleKbData, ITypeGrantedDescriptor} from "../../worklist/interfaces";

export interface ICurationState {
  workList: immutable.List<IcurationWorklistItem>;
  definitions: immutable.Map<string, any>;
  valuesets: immutable.Map<string, Map<string,string>>;
  activeKnowledgeBase: string;
  previewData: IPreviewData;
  multipleKbData: IMultipleKbData;
}

let previewDataInit: IPreviewData = {
  patient: null,
  testConfiguration: null,
  previewStatus: PreviewStatus.finish
};

let multipleKbDataInit: IMultipleKbData = {
  grantedKnowledgeBase: null,
  grantedActionsTable: []
};

const InitState: ICurationState = {
  workList: immutable.List(),
  definitions: immutable.Map(),
  valuesets: immutable.Map(),
  activeKnowledgeBase: null,
  previewData: previewDataInit,
  multipleKbData: multipleKbDataInit
};

export function curationReducer(state: ICurationState = InitState, action: IgenomicsAction): ICurationState {
  let newState: ICurationState;
  switch (action.type) {
    case CURATION_ACTIONS.INIT:
      return InitState;
    case CURATION_ACTIONS.SET_WORKLIST:
      newState = Object.assign({ }, state);
      newState.workList = immutable.List(action.payload.results);
      return newState;
    case CURATION_ACTIONS.ADD_WORKLIST_ITEM:
      newState = Object.assign({ }, state);
      newState.workList = newState.workList.concat(action.payload.results).toList();
      return newState;
    case CURATION_ACTIONS.SET_CURATION_DEFINITION:
      newState = Object.assign({ }, state);
      newState.definitions = newState.definitions.asMutable();
      newState.definitions.clear();
      action.payload.forEach(definition => {
        newState.definitions.set(definition.resource.id, definition.resource);
      });
      newState.definitions = newState.definitions.asImmutable();
      return newState;
    case CURATION_ACTIONS.SET_CURATION_VALUESETS:
      newState = Object.assign({ }, state);
      newState.valuesets = newState.valuesets.asMutable();
      action.payload.forEach(vs => { 
          newState.valuesets.set(vs.id, vs.concept);
      });
      newState.valuesets = newState.valuesets.asImmutable();
      return newState;
    case CURATION_ACTIONS.SET_CURATION_ACTIVE_KB:
      newState = Object.assign({ }, state);
      newState.activeKnowledgeBase = action.payload;
      return newState;
    case CURATION_ACTIONS.SET_CURATION_GRANTED_KB:
      newState = Object.assign({ }, state);
      newState.multipleKbData.grantedKnowledgeBase = action.payload;
      return newState;
    case CURATION_ACTIONS.SET_PREVIEW_PATIENT:
      newState = Object.assign({}, state);
      newState.previewData.patient = action.payload.patient;
      return newState;
    case CURATION_ACTIONS.SET_PREVIEW_CONFIGURATIONS:
      newState = Object.assign({}, state);
      newState.previewData.testConfiguration = action.payload.testConfiguration;
      return newState;
    case CURATION_ACTIONS.SET_PREVIEW_MODE:
      newState = Object.assign({}, state);
      newState.previewData.previewStatus  = action.payload;
      return newState;
    case CURATION_ACTIONS.SET_GRANTED_ACTIONS_TABLE:
      newState = Object.assign({}, state);
      newState.multipleKbData.grantedActionsTable  = action.payload;
      return newState;
    case CURATION_ACTIONS.SET_MULTIPLE_KB_DATA:
      newState = Object.assign({}, state);
      newState.multipleKbData  = action.payload;
      return newState;
    default:
      return state;
  }
}
